import { apiClient } from "../config";
import { ILogin } from "typed/requests/IAuth";
async function login(data: ILogin) {
  const res = await apiClient.post("/admin/login", data);

  return res.data;
}

export default login;
